export const ALL = 'all';
export const NON_EMPTY = '(non-empty)';
export const EMPTY = '(empty)';
